import { AxiosResponse } from 'axios';

import { normalizePageData } from 'utils/commonNormalizer';
import { normalizeSearchFiltersPayload } from 'utils/filters';
import { prepareFormData } from 'utils/form';
import { IAllPageFilters, IPageType } from 'utils/types';

import axiosInstance from '../base';

import { normalizeBinGroup } from './normalizers';
import { IBinGroup, IBinGroupData, IBinGroupForm } from './types';

const IBinGroupsApi = {
  async getAllBinGroups(filters: IAllPageFilters): Promise<IPageType<IBinGroup>> {
    const normalizedFilter = normalizeSearchFiltersPayload(filters);

    const response = await axiosInstance.get('bin-groups', {
      params: normalizedFilter,
    });

    return normalizePageData<IBinGroupData, IBinGroup>(
      response.data,
      normalizeBinGroup,
      JSON.stringify(filters.search),
    );
  },

  async getBinGroup(id: string): Promise<IBinGroup> {
    const response = await axiosInstance.get(`bin-groups/${id}`);

    return normalizeBinGroup(response.data);
  },

  async createBinGroup({ binList, ...others }: IBinGroupForm): Promise<AxiosResponse> {
    const normalizedPayload = prepareFormData({
      ...others,
      binList: binList && binList?.split(':').filter((bin) => !!bin),
    });

    const response = await axiosInstance.post(`bin-groups`, normalizedPayload);
    return response;
  },

  async updateBinGroup({
    binList,
    id,
    ...others
  }: IBinGroupForm): Promise<AxiosResponse> {
    const normalizedPayload = prepareFormData({
      ...others,
      binList: binList?.split(':').filter((bin) => !!bin),
    });

    const response = await axiosInstance.put(`bin-groups/${id}`, normalizedPayload);
    return response;
  },

  async deleteBinGroup(id: number): Promise<AxiosResponse> {
    const result = await axiosInstance.delete(`bin-groups/${id}`);

    return result;
  },
};

export default IBinGroupsApi;
